'use client';
import { AppImage } from '@/app/common';
import { Thumbnail as ThumbnailType } from '@workspace/interfaces';
import { sanityImageSrc } from '@/sanity/lib/image';

interface ThumbnailProps {
  thumbnail: ThumbnailType;
  onPlay: () => void;
  className?: string;
  quality?: number;
  width?: number;
}

export function Thumbnail({
  thumbnail,
  onPlay,
  className = 'absolute inset-0 w-full h-full object-cover z-10',
  quality = 95,
  width = 1920,
}: ThumbnailProps) {
  if (!thumbnail?.url) return null;

  return (
    <AppImage
      fill
      src={sanityImageSrc(thumbnail, { width, height: undefined })}
      alt={thumbnail.bynderImage?.alt || thumbnail.alt || 'Media Thumbnail'}
      className={className}
      quality={quality}
      sanityImage={thumbnail}
      onClick={onPlay}
    />
  );
}
